import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import ServiceApi from "../../services/ServiceApi";
import { UserOutlined } from "@ant-design/icons";
import axios from "axios";

const ChangePassWord = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const auth = useContext(authUserContext);
  const [form] = Form.useForm();
  const handleSubmit = (value) => {
    setErrorMessage("");
    setIsLoading(true);
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}UserChangePwd`,
      method: "POST",
      data: {
        Username: value.username,
        OldPwd: value.currentPassword,
        NewPwd: value.newPassword,
        ChkNewPwd: value.confirmNewPassword,
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          notification.success({
            message: "บันทึกสำเร็จ",
            description: "คุณได้ทำการเปลี่ยน Password สำเร็จแล้ว",
          });
          form.resetFields();
        } else {
          setErrorMessage(res.result.showText);
        }
        setIsLoading(false);
        console.log("res", res);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setIsLoading(false);
      });
  };

  return (
    <div className="container body-content bbtec-theme">
      <div className="background-100"></div>

      <div className="box-container" style={{ height: "unset" }}>
        <div>
          <select defaultValue="EN" className="form-control chang-lgg">
            <option value="EN">EN</option>
            <option value="TH">TH</option>
          </select>
        </div>
        <div className="row">
          <div
            className="col-6 offset-md-1 mt-form-log"
            style={{ marginTop: 50 }}
          >
            <div>
              <img src={ServiceApi.absoluteUrl("/img/Group_278.png")} alt="" />
            </div>
            <div
              className="font-mont"
              // id="tabs-forgetpwd"

              style={{ fontSize: 30, color: "#5C72F7", marginTop: 10 }}
            >
              Change Password
            </div>
            <div
              className="font-mont"
              style={{ fontSize: 12, color: "#999999", marginTop: 5 }}
            >
              Character, uppercase letter, lowercase letter, number.
            </div>
            <div
              className="font-mont"
              style={{ fontSize: 9, color: "#999999", marginTop: 5 }}
            >
              Example: @Abc12345.
            </div>
            <div className="row" style={{ margin: "0px -15px", marginTop: 10 }}>
              <div className="col-8">
                <Form
                  onFinish={handleSubmit}
                  form={form}
                  layout="vertical"
                  hideRequiredMark="true"
                >
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="username"
                        label="Username"
                        rules={[
                          {
                            required: true,
                            message: "Username is required",
                          },
                        ]}
                        className="for-got-password"
                      >
                        <Input
                          suffix={<UserOutlined />}
                          className="font-mont-r"
                          type="text"
                          size="large"
                          placeholder="Please enter your username"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="currentPassword"
                        label="Current Password"
                        rules={[
                          {
                            required: true,
                            message: "Current password is required",
                          },
                        ]}
                      >
                        <Input.Password
                          // suffix={<UserOutlined />}
                          className="font-mont-r"
                          type="text"
                          size="large"
                          placeholder="Enter current password"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="newPassword"
                        label="New Password"
                        rules={[
                          {
                            required: true,
                            message: "New password is required",
                          },
                        ]}
                      >
                        <Input.Password
                          size="large"
                          placeholder="Enter new password"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <Form.Item
                        name="confirmNewPassword"
                        label="Confirm New Password"
                        rules={[
                          {
                            required: true,
                            message: "Confirm new password is required",
                          },
                        ]}
                      >
                        <Input.Password
                          size="large"
                          placeholder="Enter confirm new password"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="row justify-content-md-center">
                    <div className="col-auto">
                      <p style={{ color: "#ff0028d1" }}>{errorMessage}</p>
                    </div>
                  </div>
                  <div className="row justify-content-md-center">
                    <div className="col-auto">
                      <Form.Item>
                        <Button
                          loading={isLoading}
                          size="small"
                          className="btn-warning"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0px 30px",
                          }}
                          onClick={() => form.submit()}
                        >
                          Submit
                        </Button>
                      </Form.Item>
                    </div>
                  </div>
                </Form>

                <div className="row">
                  <div
                    className="f-mon alarm-login"
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginTop: "10px",
                      padding: "15px",
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-5 d-flex flex-row-reverse"
            style={{ paddingRight: "0px", alignItems: "flex-end" }}
          >
            <div className="d-flex flex-row-reverse" align="right">
              <div
                className="change-pass-image"
                style={{ marginBottom: "-1px" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassWord;
